const defaults = require('./defaults');

const { elastic } = defaults;

module.exports = {
  ...defaults,
  mode: 'production',
  sourceMap: 'source-map',
  cacheControl: 'max-age=120',
  urlRoot: 'https://www.localsearch.com.au',
  apiRoot: 'https://daapi.lsapis.com.au',
  serviceApiRoot: 'https://services.lsapis.com.au',
  serviceGraphqlRoot: 'https://services.lsapis.com.au/graphql',
  imageResizeRoot: 'https://d2xzxktm3qm7rt.cloudfront.net',
  addABusinessRoot: 'https://digital-presence.localsearch.com.au',
  filemakerApiRoot:
    'https://03y6jplc7a.execute-api.ap-southeast-2.amazonaws.com/production',
  recaptchaMinScore: 0.5,
  gtmId: 'GTM-TZTSNVJ',
  token: {
    ...defaults.token,
    cookie: {
      domain: '.localsearch.com.au',
    },
  },
  auth: {
    ...defaults.auth,
    domain: 'ls-dashboard.au.auth0.com',
    audience: 'https://services.lsapis.com.au',
    redirectUri: 'https://www.localsearch.com.au/login-loader',
    returnTo: 'https://www.localsearch.com.au',
    clientID: 'ijkpfq4N4I23hUYvqQ0Ol0qyeCTyH5Q0',
  },
  elastic: {
    ...elastic,
    cacheControl: 'max-age=120',
    node:
      'https://vpc-ls-services-prod-6ddbsftzrxko6m625k3xif4c7u.ap-southeast-2.es.amazonaws.com',
  },
  deploy: {
    aliases: 'www.localsearch.com.au,www-prod.localsearch.cloud',
    certificateArn:
      'arn:aws:acm:us-east-1:708891215413:certificate/b28d961b-e3f0-498f-aac9-3595fa1191bd',
    legacyBucket: 'wwwresourcesprod.localsearch.com.au.s3.amazonaws.com',
    webAcl:
      'arn:aws:wafv2:us-east-1:708891215413:global/webacl/ls-www/6cc11d3e-1fcb-46cd-a3ab-a404a24e84ab',
    logBucket: 'ls-web-react-logs',
    vpcSubnetIds: ['subnet-14fe6173', 'subnet-c2129b8b'],
    vpcSecurityGroupIds: ['sg-01e194158f2ed4023', 'sg-87e953fe'],
  },
};
